module.exports = __webpack_public_path__ + "img/wsb-howtoplay-images-03.ea0bd1ba.jpg";